import { z } from 'zod';

// TODO: refine after Data Structure doc review

export const GameSettingsSchema = z.object({
  // Default to null so a freshly-created game (with `settings = '{}'::jsonb`)
  // parses without forcing every writer to populate every key.
  feedbackChannelId: z.string().nullable().default(null),
  dmConsentRequired: z.boolean().default(true),
  defaultLanguage: z.string().default('en'),
  // TODO: extend with onboarding-state and progressive setup fields
});
export type GameSettings = z.infer<typeof GameSettingsSchema>;

// Target platforms a game ships to. Source of truth for milestone platform
// scope, publishing-destination availability, and future analytics
// segmentation. The ordering here is the canonical render order for UI lists.
export const GamePlatformSchema = z.enum([
  'pc',
  'mac',
  'linux',
  'ios',
  'android',
  'console',
  'vr',
]);
export type GamePlatform = z.infer<typeof GamePlatformSchema>;

// How readily the Insights pipeline graduates clusters into themes. One dial
// per game; the integer mapping lives in the bot so we can re-tune without a
// UI release. 'high' (default) matches the current MVP threshold.
export const ThemeSensitivitySchema = z.enum(['high', 'balanced', 'low']);
export type ThemeSensitivity = z.infer<typeof ThemeSensitivitySchema>;

export const GameSchema = z.object({
  id: z.string().uuid(),
  studioId: z.string().uuid(),
  name: z.string().min(1),
  slug: z.string().min(1),
  // Opaque, stable URL identifier (migration 0113). Not derived from the name,
  // so it survives renames - portal routes key on this rather than slug.
  shortId: z.string().min(1),
  settings: GameSettingsSchema,
  targetPlatforms: z.array(GamePlatformSchema).default([]),
  themeSensitivity: ThemeSensitivitySchema.default('high'),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});
export type Game = z.infer<typeof GameSchema>;
